import { getSystemLocationCourtsUseCase } from '@/domain/use-cases/system-locations/get-system-location-courts.use-case';
import { Result } from '@/entities';
import { SystemLocationsCourts } from '@/entities/SystemLocationsCourts';

export const getSystemLocationCourtsController = async (
	moduleFor: string,
	moduleUuid: string,
	locationId: string
): Promise<Result<SystemLocationsCourts[]>> => {
	return getSystemLocationCourtsUseCase(moduleFor, moduleUuid, locationId);
};
